import { Entity } from '@api';
import { MentionChipKind } from '@design/components/mention-chip/MentionChip';
import { Theme } from '@terminal/components/search-modal/utils';

export const MENTION_TYPES = [
  'entity',
  'theme',
  'list',
  'public-list',
] as const;
export type MentionType = (typeof MENTION_TYPES)[number];

const MENTION_TYPE_SET = new Set<string>(MENTION_TYPES);

export const isMentionType = (value: string): value is MentionType =>
  MENTION_TYPE_SET.has(value);

export const MAX_MENTIONS_PER_REQUEST = 100;

export interface Mention {
  type: MentionType;
  id: string;
  name: string;
  label: string;
}

export interface MentionEntityCandidate {
  kind: 'entity';
  id: string;
  label: string;
  entity: Entity;
}

export interface MentionThemeCandidate {
  kind: 'theme';
  id: string;
  label: string;
  theme: Theme;
}

export type MentionAssetCandidate =
  | MentionEntityCandidate
  | MentionThemeCandidate;

export interface MentionWatchlistCandidate {
  kind: 'list' | 'public-list';
  id: string;
  label: string;
}

export type MentionCandidate =
  | MentionAssetCandidate
  | MentionWatchlistCandidate;

export const mentionTypeToChipKind = (type: MentionType): MentionChipKind =>
  type === 'list' || type === 'public-list' ? 'watchlist' : type;

export const mentionCandidateToMention = (
  candidate: MentionCandidate
): Mention => ({
  type: candidate.kind,
  id: candidate.id,
  name: candidate.label,
  label: candidate.label,
});
